import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ChefHat, Bath, Home, Paintbrush as PaintbrushIcon, FileSignature, Wrench, Hammer, Ruler } from 'lucide-react';
const services = [{
  title: 'Kitchen Remodeling',
  description: 'Modern and functional designs. From custom cabinetry to premium countertops and space optimization.',
  icon: <ChefHat size={32} data-id="element-239" />
}, {
  title: 'Bathroom Remodeling',
  description: 'We transform your bathroom into a relaxation oasis with luxury finishes, modern plumbing, and efficient design.',
  icon: <Bath size={32} data-id="element-240" />
}, {
  title: 'Home Additions',
  description: 'We add value and space to your home with structurally sound extensions that seamlessly integrate with the original design.',
  icon: <Home size={32} data-id="element-241" />
}, {
  title: 'Flooring & Finishes',
  description: 'Professional installation of hardwood, ceramic, marble, and high-quality paint finishes for interiors and exteriors.',
  icon: <PaintbrushIcon size={32} data-id="element-242" />
}, {
  title: 'Interior and Exterior Painting',
  description: 'Expert painting services with meticulous attention to detail. We deliver flawless finishes using premium materials, ensuring lasting beauty and protection for every surface of your home.',
  icon: <PaintbrushIcon size={32} data-id="element-243" />
}, {
  title: 'Permits & Supervision',
  description: 'Complete management of municipal permits and on-site supervision at every stage. We ensure full code compliance, safety standards, and seamless coordination so your project stays on track.',
  icon: <FileSignature size={32} data-id="element-244" />
}, {
  title: 'Masonry & Hardscaping',
  description: "Expert brick, stone, and concrete work for patios, retaining walls, walkways, and outdoor living spaces. We craft durable, beautiful hardscape features that elevate your property's curb appeal and value.",
  icon: <Hammer size={32} data-id="element-245" />
}, {
  title: 'Carpentry & Finishing',
  description: 'Detail-oriented custom carpentry tailored to your vision. From crown molding and trim work to built-in shelving and custom cabinetry, we optimize every inch with precision craftsmanship and personalized design.',
  icon: <Ruler size={32} data-id="element-246" />
}, {
  title: 'Full Remodeling',
  description: 'Comprehensive property renovations, coordinating all trades for a hassle-free turnkey delivery.',
  icon: <Wrench size={32} data-id="element-247" />
}];
export function Services() {
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="services" className="py-24 bg-light-alt" data-id="element-248">
      <div className="container mx-auto px-6 md:px-12" data-id="element-249">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-250">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-251">
            <h2 className="text-accent font-medium tracking-widest uppercase text-sm mb-3" data-id="element-252">
              Our Expertise
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-6" data-id="element-253">
              Construction Services
            </h3>
            <p className="text-gray-600 text-lg" data-id="element-254">
              We offer comprehensive solutions for every aspect of your
              remodeling project, guaranteeing quality, durability, and beauty
              in every detail.
            </p>
          </motion.div>
        </div>

        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-255">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-10 rounded-sm shadow-sm hover:shadow-xl transition-shadow duration-300 border-b-4 border-transparent hover:border-accent group" data-id="element-256">
              <div className="w-16 h-16 bg-light flex items-center justify-center rounded-sm text-primary mb-6 group-hover:bg-accent group-hover:text-white transition-colors duration-300" data-id="element-257">
                {service.icon}
              </div>
              <h4 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-258">
                {service.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-259">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}